import { safeInternalRedirect } from "@/utils/internalRedirect";
// Router module dependencies
import { createRouter, createWebHashHistory } from "vue-router";
import { useProjectsSearchStore } from "@/app/stores/projectsSearchStore";
// Authentication
import auth from "@/api/auth/auth";

// Components
import Home from "@/views/Home.vue";
//import common from '@/api/services/common.service';
import Auth from "@/views/auth/Auth.vue";
import Login from "@/views/auth/Login.vue";
import Employee from "@/views/employee/Employee.vue";
import MyData from "@/views/employee/MyData.vue";
import EmployeeItem from "@/views/employee/EmployeeItem.vue";
import Holidays from "@/views/holidays/Holidays.vue";
import { useTeamHolidaysStore } from "@/app/stores/teamHolidaysStore";
import HolidayItem from "@/views/holidays/HolidayItem.vue";
import EmployeeCalendar from "@/views/employee/EmployeeCalendar.vue";
/* import PresenceHome from "@/views/presence/PresenceHome.vue" */
import ShowCurrentPresence from "@/views/presence/ShowCurrentPresence.vue";
import ShowMyPresence from "@/views/presence/ShowMyPresence.vue";
/* import PresenceReport from "@/views/presence/PresenceReport.vue" */
import PresenceReportNew from "@/views/presence/PresenceReportNew.vue";
import ManagePresence from "@/views/presence/ManagePresence.vue";
import Job from "@/views/masters/job/Job.vue";
import JobItem from "@/views/masters/job/JobItem.vue";
import Department from "@/views/masters/department/Department.vue";
import Workplace from "@/views/masters/workplace/Workplace.vue";
import Provider from "@/views/masters/provider/Provider.vue";
import WorkplaceItem from "@/views/masters/workplace/WorkplaceItem.vue";
import LeaveType from "@/views/masters/leavetype/LeaveType.vue";
import AbsenceType from "@/views/masters/absencetype/AbsenceType.vue";
import Absence from "@/views/absence/Absence.vue";
import MyAbsences from "@/views/absence/MyAbsences.vue";
import AbsenceItem from "@/views/absence/AbsenceItem.vue";
import HolidayIncompatibilities from "@/views/masters/holiday/HolidayIncompatibilities.vue";
import HolidayCalendar from "@/views/masters/holidayCalendar/HolidayCalendar.vue";
import Schedule from "@/views/masters/schedule/Schedule.vue";
import ProductionDashboard from "@/views/production/ProductionDashboard.vue";
import ProductionProjectsDashboard from "@/views/production/ProductionProjectsDashboard.vue";
import ChangePassword from "@/views/auth/ChangePassword.vue";
import RecoverPassword from "@/views/auth/RecoverPassword.vue";
import ConfirmPasswordReset from "@/views/auth/ConfirmPasswordReset.vue";
// import SearchProjects from "@/views/projects/SearchProjects.vue";
import ShowProject from "@/views/projects/ShowProject.vue";
import CreateProject from "@/views/projects/CreateProject.vue";
import SuggestionsSearch from "@/views/suggestions/SuggestionsSearch.vue";
import SuggestionsUpdate from "@/views/suggestions/SuggestionsUpdate.vue";
import MySuggestions from "@/views/suggestions/MySuggestions.vue";
import FormSuggestion from "@/views/suggestions/FormSuggestion.vue";
import ListUnadews from "@/views/communication/listUndanews.vue";
import ListUndanitas from "@/views/communication/listUndanitas.vue";
import FormUndanews from "@/views/communication/FormUndanews.vue";
import FormUndanitas from "@/views/communication/FormUndanitas.vue";
import MeetingRoomReservation from "@/views/communication/MeetingRoomReservation.vue";
import SearchBenefits from "@/views/benefits/SearchBenefits.vue";
import MyBenefit from "@/views/benefits/MyBenefit.vue";
import FormBenefit from "@/views/benefits/FormBenefit.vue";
import UpdateBenefit from "@/views/benefits/UpdateBenefit.vue";
import DomainsSearch from "@/views/domain/DomainsSearch.vue";
import Tickets from "@/views/tickets/Tickets.vue";
import ListClients from "@/views/clients/ListClients.vue";
import EditClient from "@/views/clients/EditClient.vue";
import TicketNew from "@/views/tickets/TicketNew.vue";
import TicketUpdate from "@/views/tickets/TicketUpdate.vue";
import InternalTicketNew from "@/views/internal-tickets/InternalTicketNew.vue";
import InternalTickets from "@/views/internal-tickets/InternalTickets.vue";
import InternalTicketUpdate from "@/views/internal-tickets/InternalTicketUpdate.vue";
import TrackerNet from "@/views/tracker-net/TrackerNet.vue";
import TrackerNetReport from "@/views/tracker-net/TrackerNetReport.vue";
import SearchProjects from "@/views/projects/SearchProjects.vue";
import Collaborators from "@/views/collaborators/Collaborators.vue";
import CollaboratorItem from "@/views/collaborators/CollaboratorItem.vue";
import MaterialDelivery from "@/views/material/MaterialDelivery.vue";
import Material from "@/views/material/Material.vue";
import MyMaterial from "@/views/material/MyMaterial.vue";
import RequestMaterialAdmin from "@/views/material/RequestMaterialAdmin.vue";
import Training from "@/views/training/Training.vue";
import CourseForm from "@/views/training/CourseForm.vue";
import Vehicle from "@/views/vehicle/Vehicle.vue";
import VehicleItem from "@/views/vehicle/VehicleItem.vue";
import VehicleRequest from "@/views/vehicle/VehicleRequest.vue";
import RequestCourse from "@/views/training/RequestCourse.vue";
import OwnerReport from "@/views/administration/OwnerReport.vue";
import SecurityDashboard from "@/views/security/SecurityDashboard.vue";
import InternalUsers from "@/views/security/InternalUsers.vue";
import ExternalUsers from "@/views/security/ExternalUsers.vue";
import UserPermissions from "@/views/security/UserPermissions.vue";
import PermissionCatalog from "@/views/security/PermissionCatalog.vue";
import PermissionProfiles from "@/views/security/PermissionProfiles.vue";
import InvoiceList from "@/views/invoices/InvoiceList.vue";
import InvoiceDetail from "@/views/invoices/InvoiceDetail.vue";
import ApiApplications from "@/views/security/ApiApplications.vue";
import ApiApplicationPermissions from "@/views/security/ApiApplicationPermissions.vue";
import SecurityAudit from "@/views/security/SecurityAudit.vue";
import Impersonations from "@/views/security/Impersonations.vue";
import SocialFundCalls from "@/views/social-fund/SocialFundCalls.vue";
import SocialFundRequests from "@/views/social-fund/SocialFundRequests.vue";
import SocialFundRequestDetail from "@/views/social-fund/SocialFundRequestDetail.vue";
import SecurityConfiguration from "@/views/security/SecurityConfiguration.vue";

import { useAuthStore } from "@/app/stores/authStore";
import {
  canAccessSecurityPermissions,
  canAccessSecurityApiApplications,
  canAccessSecurityAudit,
  canAccessImpersonations,
  canAccessSecurityDashboard,
} from "@/utils/securityAccess";
const TRAINING_ALLOWED_EMAILS = [
  "jgarcia@undanet.com",
  "jcamacho@undanet.com",
  "faguilar@undanet.com",
  "andrearodriguez@undanet.com",
];
const TRAINING_ALLOWED_ROUTE_NAMES = [
  "training",
  "new_course",
  "course_edit",
  "request-courses",
];
const USER_PERMISSION_ROUTE_ROLES = [
  "ROLE_USER",
  "ROLE_ADMIN",
  "ROLE_SYSTEMS",
  "ROLE_EXTERNAL_COLLABORATOR",
  "ROLE_CUSTOMER_ADMIN",
];

// Methods
const redirectTo = () => {
  return "/home";
};

// Routes
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/my-data",
      name: "my-data",
      component: MyData,
      meta: { requiresAuth: true },
    },
    {
      path: "/employees",
      name: "employees",
      component: Employee,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/employees/:id",
      name: "employee",
      component: EmployeeItem,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/providers",
      name: "providers",
      component: Provider,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/collaborators",
      name: "collaborators",
      component: Collaborators,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/collaborators/:id",
      name: "collaborator",
      component: CollaboratorItem,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/my-absences",
      name: "my-absences",
      component: MyAbsences,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/absences",
      name: "absences",
      component: Absence,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/absences/:id",
      name: "absence",
      component: AbsenceItem,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/holidays",
      name: "holidays",
      component: Holidays,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/my-team",
      name: "my-team",
      component: () => import("@/views/team-holidays/TeamHolidays.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/holidays/:id",
      name: "holiday",
      component: HolidayItem,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/calendar",
      name: "calendar",
      component: EmployeeCalendar,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/my-material",
      name: "my-material",
      component: MyMaterial,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/presence",
      name: "presence",
      component: ShowCurrentPresence,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/employee-presence/:id",
      name: "employee-presence",
      component: ShowMyPresence,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/presence-report",
      name: "presence-report",
      component: PresenceReportNew,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/manage-presence",
      name: "manage-presence",
      component: ManagePresence,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/manage-presence/:id",
      name: "manage-presence-user",
      component: ManagePresence,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/jobs",
      name: "jobs",
      component: Job,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/jobs/:id",
      name: "job",
      component: JobItem,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/departments",
      name: "departments",
      component: Department,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/workplaces",
      name: "workplaces",
      component: Workplace,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/workplaces/:id",
      name: "workplace",
      component: WorkplaceItem,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/leave_types",
      name: "leave-types",
      component: LeaveType,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/absence_types",
      name: "absence-types",
      component: AbsenceType,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/holiday-incompatibilities",
      name: "holiday-incompatibilities",
      component: HolidayIncompatibilities,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/holiday-calendar",
      name: "holiday-calendar",
      component: HolidayCalendar,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/schedules",
      name: "schedules",
      component: Schedule,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/production",
      name: "production",
      component: ProductionDashboard,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/production/project-dashboard",
      name: "production-project-dashboard",
      component: ProductionProjectsDashboard,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/projects",
      name: "projects",
      component: SearchProjects,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/projects/new",
      name: "create-project",
      component: CreateProject,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/show-projects/:id",
      name: "show-projects",
      component: ShowProject,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/clients",
      name: "clients",
      component: ListClients,
      meta: { requiresAuth: true, roles: ["ROLE_SYSTEMS", "ROLE_ADMIN"] },
    },
    {
      path: "/clients/new",
      name: "create-client",
      component: EditClient,
      meta: { requiresAuth: true, roles: ["ROLE_SYSTEMS", "ROLE_ADMIN"] },
    },
    {
      path: "/clients/:id",
      name: "show-client",
      component: EditClient,
      meta: { requiresAuth: true, roles: ["ROLE_SYSTEMS", "ROLE_ADMIN"] },
    },

    {
      path: "/benefits",
      name: "benefits-search",
      component: SearchBenefits,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/benefits",
      name: "create-benefits",
      component: FormBenefit,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/benefits/:id",
      name: "update-benefit",
      component: UpdateBenefit,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/mybenefits",
      name: "my-benefits",
      component: MyBenefit,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN", "ROLE_USER"] },
    },
    {
      path: "/training",
      name: "training",
      component: Training,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN", "ROLE_USER"] },
    },
    {
      path: "/requestCourses",
      name: "request-courses",
      component: RequestCourse,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN", "ROLE_USER"] },
    },

    {
      path: "/suggestions",
      name: "suggestions-search",
      component: SuggestionsSearch,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/suggestions/:id",
      name: "suggestions-update",
      component: SuggestionsUpdate,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/mysuggestions/:id",
      name: "my-suggestions",
      component: MySuggestions,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/createsuggestion",
      name: "createsuggestion",
      component: FormSuggestion,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/tracker",
      name: "tracker",
      component: TrackerNet,
      meta: {
        requiresAuth: true,
        roles: USER_PERMISSION_ROUTE_ROLES,
      },
    },
    {
      path: "/tracker-report",
      name: "tracker-report",
      component: TrackerNetReport,
      meta: {
        requiresAuth: true,
        roles: USER_PERMISSION_ROUTE_ROLES,
      },
    },
    {
      path: "/administration/owner-report",
      name: "owner-report",
      component: OwnerReport,
      meta: {
        requiresAuth: true,
        roles: USER_PERMISSION_ROUTE_ROLES,
      },
    },
    {
      path: "/security",
      name: "security",
      component: SecurityDashboard,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/security/internal-users",
      name: "security-internal-users",
      component: InternalUsers,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/security/external-users",
      name: "security-external-users",
      component: ExternalUsers,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/security/user-permissions",
      name: "security-user-permissions",
      component: UserPermissions,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/security/permission-catalog",
      name: "security-permission-catalog",
      component: PermissionCatalog,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/security/permission-profiles",
      name: "security-permission-profiles",
      component: PermissionProfiles,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/security/api-applications",
      name: "security-api-applications",
      component: ApiApplications,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/security/api-applications/:id",
      name: "security-api-application-permissions",
      component: ApiApplicationPermissions,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/security/audit",
      name: "security-audit",
      component: SecurityAudit,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/security/impersonations",
      name: "security-impersonations",
      component: Impersonations,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/security/configuration",
      name: "security-configuration",
      component: SecurityConfiguration,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/social-fund/calls",
      name: "social-fund-calls",
      component: SocialFundCalls,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN", "ROLE_USER"] },
    },
    {
      path: "/social-fund/requests",
      name: "social-fund-requests",
      component: SocialFundRequests,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN", "ROLE_USER"] },
    },
    {
      path: "/social-fund/requests/:id",
      name: "social-fund-request-detail",
      component: SocialFundRequestDetail,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN", "ROLE_USER"] },
    },
    {
      path: "/change-password",
      name: "change-password",
      component: ChangePassword,
      meta: {
        title: "Mi cuenta · Seguridad",
        requiresAuth: true,
      },
    },
    {
      path: "/undanews",
      name: "undanews",
      component: ListUnadews,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/new_undanews",
      name: "new_undanews",
      component: FormUndanews,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/new_undanews/:id",
      name: "update_undanews",
      component: FormUndanews,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/undanitas",
      name: "undanitas",
      component: ListUndanitas,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/new_undanitas",
      name: "new_undanitas",
      component: FormUndanitas,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/undanitas/:id",
      name: "update_undanitas",
      component: FormUndanitas,
      meta: { requiresAuth: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/systems/material-delivery",
      name: "material-delivery",
      component: MaterialDelivery,
      meta: { requiresAuth: true, roles: ["ROLE_SYSTEMS", "ROLE_ADMIN"] },
    },
    {
      path: "/systems/material",
      name: "material",
      component: Material,
      meta: { requiresAuth: true, roles: ["ROLE_SYSTEMS", "ROLE_ADMIN"] },
    },
    {
      path: "/systems/request-material",
      name: "request-material",
      component: RequestMaterialAdmin,
      meta: { requiresAuth: true, roles: ["ROLE_SYSTEMS", "ROLE_ADMIN"] },
    },
    {
      path: "/systems/domains",
      name: "domains-search",
      component: DomainsSearch,
      meta: { requiresAuth: true, roles: ["ROLE_SYSTEMS", "ROLE_ADMIN"] },
    },
    {
      path: "/systems/tickets",
      name: "tickets",
      component: Tickets,
      meta: { requiresAuth: true, disabled: true, roles: ["ROLE_SYSTEMS", "ROLE_ADMIN"] },
    },
    {
      path: "/systems/tickets/new",
      name: "new_ticket",
      component: TicketNew,
      meta: { requiresAuth: true, disabled: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/systems/tickets/:id",
      name: "update_ticket",
      component: TicketUpdate,
      meta: { requiresAuth: true, disabled: true, roles: ["ROLE_USER", "ROLE_ADMIN"] },
    },
    {
      path: "/internal-tickets",
      name: "internal_tickets",
      component: InternalTickets,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/internal-tickets/new",
      name: "new_internal_ticket",
      component: InternalTicketNew,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/internal-tickets/:id",
      name: "update_internal_ticket",
      component: InternalTicketUpdate,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/training/newCourse",
      name: "new_course",
      component: CourseForm,
      meta: { requiresAuth: true, roles: ["ROLE_USER"] },
    },
    {
      path: "/training/course/:id",
      name: "course_edit",
      component: CourseForm,
      meta: { requiresAuth: true, roles: ["ROLE_USER"] },
    },
    {
      path: "/vehicles",
      name: "vehicles",
      component: Vehicle,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/vehicle/:id",
      name: "vehicle",
      component: VehicleItem,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/vehicle/new",
      name: "vehicle_new",
      component: VehicleItem,
      meta: { requiresAuth: true, roles: ["ROLE_ADMIN"] },
    },
    {
      path: "/vehicle-requests",
      name: "vehicle-requests",
      component: VehicleRequest,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/meeting-room-reservations",
      name: "meeting-room-reservations",
      component: MeetingRoomReservation,
      meta: { requiresAuth: true, roles: ["ROLE_USER"] },
    },
    {
      path: "/invoices",
      name: "invoices",
      component: InvoiceList,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/invoices/:id",
      name: "invoice",
      component: InvoiceDetail,
      meta: { requiresAuth: true, roles: USER_PERMISSION_ROUTE_ROLES },
    },
    {
      path: "/auth",
      name: "auth",
      component: Auth,
      redirect: "login",
      children: [
        {
          path: "/login",
          name: "login",
          component: Login,
        },
        {
          path: "/recover-password",
          name: "recover-password",
          component: RecoverPassword,
        },
        {
          path: "/confirm-password-reset",
          name: "confirm-password-reset",
          component: ConfirmPasswordReset,
        },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: redirectTo(),
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  // Los módulos deshabilitados no admiten acceso por URL ni por nombre de ruta.
  if (to.matched.some((record) => record.meta.disabled)) {
    return next({ name: "home", replace: true });
  }

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !auth.checkAuth()) {
    return next({ name: "login", query: { redirect: to.fullPath } });
  }

  const authStore = useAuthStore();
  const user = authStore.getUserLogged;

  // A stored token without a hydrated user must still be allowed to log in.
  if (to.name === "login" && user && auth.checkAuth()) {
    return next(safeInternalRedirect(to.query.redirect) || { name: "home" });
  }

  if (requiresAuth && !user) {
    return next({ name: "login", query: { redirect: to.fullPath } });
  }

  if (!requiresAuth || !user) {
    return next();
  }

  const userRoles = Array.isArray(user.roles) ? user.roles : [];
  const hasRoleAdmin = userRoles.includes("ROLE_ADMIN");
  const hasRoleSystems = userRoles.includes("ROLE_SYSTEMS");
  const userPermissions = Array.isArray(user.permissions)
    ? user.permissions
    : [];
  // trackernet:use / trackernet:reports: permisos granulares backfilled desde
  // los flags legacy (Version20260716105948) — se comprueban además del flag
  // por si un empleado se da de alta ya solo con el permiso granular.
  const canCreateTimeEntry =
    user.canCreateTimeEntry || userPermissions.includes("trackernet:use");
  const canAccessTrackernetReport =
    user.accessTrackerNetReports ||
    userPermissions.includes("trackernet:reports");
  // tickets:internal / vehicles:use: mismo patrón que trackernet:use arriba
  // (backfill vía Version20260716105948).
  const canAccessInternalTickets =
    user.accessInternalTickets || userPermissions.includes("tickets:internal");
  const canAccessVehicleRequests =
    user.accessVehicleRequests ||
    user.accessVehicleModule ||
    userPermissions.includes("vehicles:use");
  const hasRoleCollaborator = userRoles.includes("ROLE_EXTERNAL_COLLABORATOR");
  const userEmail = (user.email || "").toLowerCase();
  const canAccessTrainingRoutes = TRAINING_ALLOWED_EMAILS.includes(userEmail);
  // Restricción de negocio: a diferencia del resto de módulos, ROLE_ADMIN NO
  // da acceso por sí solo a Facturación — solo quien tenga invoices:view (o
  // invoices:manage) concedido explícitamente.
  const canAccessInvoices =
    userPermissions.includes("invoices:view") ||
    userPermissions.includes("invoices:manage");
  // Restricción de negocio (igual que Facturación): ROLE_ADMIN NO da acceso
  // por sí solo a Fondo Social — hace falta el permiso concedido explícitamente.
  const canAccessSocialFund = userPermissions.includes("fondo_social:view_all");
  const canManageSocialFundCalls = userPermissions.includes(
    "fondo_social:manage",
  );
  const canAccessSecurityPermissionsScreens = canAccessSecurityPermissions(
    userRoles,
    userPermissions,
  );
  const canAccessSecurityApiApplicationsScreens =
    canAccessSecurityApiApplications(userRoles, userPermissions);
  const canAccessSecurityAuditScreen = canAccessSecurityAudit(
    userRoles,
    userPermissions,
  );
  const canAccessImpersonationsScreen = canAccessImpersonations(
    userRoles,
    userPermissions,
  );
  const canAccessSecurityDashboardScreen = canAccessSecurityDashboard(
    userRoles,
    userPermissions,
  );
  const allowedRoles = to.matched.flatMap((record) => record.meta.roles || []);
  const hasAllowedRole =
    allowedRoles.length === 0 ||
    allowedRoles.some((role) => userRoles.includes(role));

  if (
    TRAINING_ALLOWED_ROUTE_NAMES.includes(to.name) &&
    !canAccessTrainingRoutes
  ) {
    return next({ name: "home" });
  }

  if (!hasAllowedRole) {
    return next({ name: hasRoleCollaborator ? "tracker" : "home" });
  }

  switch (to.name) {
    case "my-team": {
      const teamStore = useTeamHolidaysStore();
      try {
        await teamStore.loadEmployee(user.id, true);
        if (String(authStore.getUserLogged?.id) !== String(user.id)) return next(false);
        if (!teamStore.canAccessFor(authStore.getUserLogged))
          return next({ name: "home" });
      } catch {
        if (String(authStore.getUserLogged?.id) !== String(user.id)) return next(false);
        return next({ name: "home" });
      }
      break;
    }
    case "my-data":
      if (hasRoleCollaborator) {
        return next({ name: "tracker" });
      }
      break;
    case "tracker":
      if (!canCreateTimeEntry && !hasRoleCollaborator && !hasRoleAdmin) {
        return next({ name: "home" });
      }
      break;
    case "internal_tickets":
    case "new_internal_ticket":
    case "update_internal_ticket":
      if (!canAccessInternalTickets && !hasRoleAdmin && !hasRoleSystems) {
        return next({ name: "home" });
      }
      break;
    case "tracker-report":
    case "owner-report":
      if (!canAccessTrackernetReport && !hasRoleAdmin) {
        return next({ name: "home" });
      }
      break;
    case "vehicle-requests":
      if (!canAccessVehicleRequests && !hasRoleAdmin) {
        return next({ name: "home" });
      }
      break;
    case "invoices":
    case "invoice":
      if (!canAccessInvoices) {
        return next({ name: "home" });
      }
      break;
    case "social-fund-requests":
    case "social-fund-request-detail":
      if (!canAccessSocialFund) {
        return next({ name: "home" });
      }
      break;
    case "social-fund-calls":
      if (!canManageSocialFundCalls) {
        return next({ name: "home" });
      }
      break;
    case "security":
      if (!canAccessSecurityDashboardScreen) {
        return next({ name: "home" });
      }
      break;
    case "security-internal-users":
    case "security-external-users":
    case "security-user-permissions":
    case "security-permission-catalog":
    case "security-permission-profiles":
      if (!canAccessSecurityPermissionsScreens) {
        return next({ name: "home" });
      }
      break;
    case "security-api-applications":
    case "security-api-application-permissions":
      if (!canAccessSecurityApiApplicationsScreens) {
        return next({ name: "home" });
      }
      break;
    case "security-audit":
      if (!canAccessSecurityAuditScreen) {
        return next({ name: "home" });
      }
      break;
    case "security-impersonations":
      if (!canAccessImpersonationsScreen) {
        return next({ name: "home" });
      }
      break;
    case "change-password":
      break;
    case "my-suggestions":
    case "suggestions-update":
    case "createsuggestion":
      break;
    default:
      if (hasRoleCollaborator) {
        return next({ name: "tracker" });
      }
      break;
  }

  return next();
});

// router.beforeEach((to, from, next) => {
//   var requiresAuth = to.matched.some( record => record.meta.requiresAuth );
//   var currentUser = false;
//   // when route requires auth and there's no current user, reidrect to '/login'
//   if(requiresAuth && !currentUser){
//     next('/login');
//   // when we go to login route and are already logged in, we can skip this page
//   // so we redirect to the homepage
//   } else if (to.path == '/login' && currentUser){
//     next('/');
//   // if none of the above matches, we have a normal navigation that should just go through
//   // so we call `next()`
//   } else {
//     next(); // you called `next('/')` which redirected to the homepage over and over again.
//   }
// });

// Aplicar solo navegaciones completadas: una salida cancelada conserva la búsqueda.
router.afterEach((to, from, failure) => {
  if (!failure) useProjectsSearchStore().handleNavigation(to, from);
});

export default router;
